import { Component, OnInit } from '@angular/core';
import { AppViewStates } from 'src/logic/enum/app-view-states';
import { Model } from 'src/logic/model';

@Component({
    selector: 'app-main',
    templateUrl: './main.component.html',
    styleUrls: ['./main.component.less'],
    standalone: false
})
export class MainComponent implements OnInit {

  constructor(public model: Model) { }

  title = 'CodersAssist';

  public AppViewStates = AppViewStates;

  ngOnInit(): void {
  }

  isMessagesVisible(){
    return this.model.messages().filter(m=>!m.removed).length > 0;
  }
}
